import { AdminToolArticleGroupsResult } from "../../../models/interfaces/articles/admin-tool-article-groups-result";
import Article from "../../../models/interfaces/articles/article";
import { ArticlesGroup } from "../../../models/interfaces/articles/articles-group";
import { Assessment } from "../../../models/interfaces/scores/assessment";
import { ServiceBase } from "../service-base";

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = `/articles`;
const getArticlesGroupEndpoint = `${baseEndpoint}/get-articles`;
const getByFmsArticleId = `${baseEndpoint}/byFmsArticleId/:id`;
const defaultExpiration = 86400 * 1000; // one day in milliseconds
const getAdminToolPrimaryArticleGroupEndpoint = `${baseEndpoint}/admin-tool-list-primary-article-groups`;
const getAdminToolPseudoArticleGroupEndpoint = `${baseEndpoint}/admin-tool-list-pseudo-article-groups`;

interface GetByFmsArticleIdParams {
    id: string;
}

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const ArticleApiService = {
    /**
     * Loads articles for the assessment group
     */
    getArticlesGroup: ServiceBase.post<ArticlesGroup, Assessment>(
        getArticlesGroupEndpoint
    ),
    getByFmsArticleId: ServiceBase.get<Article, GetByFmsArticleIdParams>(
        getByFmsArticleId,
        defaultExpiration
    ),
    /**
     * Gets primary article groups for admin tool
     */
    getAdminToolPrimaryArticleGroups:
        ServiceBase.list<AdminToolArticleGroupsResult[]>(getAdminToolPrimaryArticleGroupEndpoint),

    /**
     * Gets pseudo article groups for admin tool
     */
    getPseudoArticleGroups:
        ServiceBase.list<AdminToolArticleGroupsResult[]>(getAdminToolPseudoArticleGroupEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default ArticleApiService;

// #endregion Exports
